import { OptionsFileIcon } from 'assets/icons/OptionsFileIcon'
import { IconContainer } from 'pages/Accomodation/Accommodation.style'
import { Flex } from 'styling/GlobalStyles'
import { BodyText } from 'styling/Typography'

export const NoData = ({ icon, text }: { icon?: any, text?: string }) => {
    return <Flex center justcenter height='15rem' column gap='1rem' >
        <IconContainer>
            {icon || <OptionsFileIcon />}
        </IconContainer>
        <BodyText grey>{text || 'There is no data for display'}</BodyText>
    </Flex>
}